import { PaginationButton } from './PaginationButton';

// TODO: in v9, move styled() from PaginationButton.jsx to here
export var StyledPaginationButton = PaginationButton;